import React, { CSSProperties, FC, useRef, useState } from 'react'
import { UploadButton, UploadContainer } from './styles'
import { observer } from 'mobx-react'
import { useAnimation } from './hooks'
import UploadArrow from '@images/UploadArrow.svg'
import { VideoInfoStore } from '@entities/VideoCaptureStore'
import { VideoHttpService } from '@entities/video/api'
import { useQueryParam } from '@shared/hooks/useQueryParams'
import { VideoResults } from '@entities/video'
import { useAlert } from '@app/ToastProvider'

interface UploadVideoProps {
	style?: CSSProperties
}

export const UploadVideo: FC<UploadVideoProps> = observer(({ style }) => {
	const title: string | undefined = useQueryParam('title')
	const videoInfoStore: VideoInfoStore = VideoInfoStore.instance
	const { backgroundImage, pointsAmount } = useAnimation()
	const fileInputRef = useRef<HTMLInputElement>(null)
	const [progress, setProgress] = useState<number>(0)

	const handleSubmitVideo = () => {
		fileInputRef.current?.click()
	}

	const uploadVideo = async (video: File): Promise<string | boolean> => {
		videoInfoStore.isVideoLoading = true
		if (!title) {
			return false
		}
		videoInfoStore.video = video
		return await VideoHttpService.submitVideo(exerciseTitle, video)
	}

	const getVideoProgress = async (uuid: string): Promise<number | undefined> => {
		await new Promise(resolve => setTimeout(resolve, 3000))
		const videoInfo: false | VideoResults = await VideoHttpService.getVideoStatus(uuid)
		if (!videoInfo) {
			return -1
		}
		setProgress(videoInfo.progress)
		if (videoInfo.progress === 100) {
			console.log('ВСЕЕЕЕЕЕ')
			console.log(videoInfo.result.full_analysis)
			videoInfoStore.recommendations = videoInfo.result.windows_analysis
			await videoInfoStore.setVideoOverlay(videoInfo.result.results)
			return videoInfo.result.frames_total
		}
		await getVideoProgress(uuid)
	}

	const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
		const file: File | undefined = event.target.files?.[0]

		if (!file) {
			return
		}
		const uuid: string | boolean = await uploadVideo(file)
		console.log('UUID: ', uuid)

		if (!uuid || typeof uuid === 'boolean') {
			useAlert({
				header: 'Ошибка сети',
				message: 'Кажется, произошла какая-то ошибка во время отправки видео',
			})
			return
		}
		await getVideoProgress(uuid)
		// await getVideoProgress('18857b8a-2337-425f-bed0-5f77bc5b1e7c') // TEST MODE
		await videoInfoStore.setUpFrames(file)
		videoInfoStore.isVideoLoading = false
		videoInfoStore.isCaptured = true
	}

	if (!videoInfoStore.isVideoLoading) {
		return (
			<UploadContainer
				style={{
					...style,
				}}>
				<UploadButton onClick={handleSubmitVideo}>
					<img src={UploadArrow} alt={'Загрузить'} />
					<div>Загрузить видео</div>
				</UploadButton>
				<input
					type='file'
					ref={fileInputRef}
					style={{ display: 'none' }}
					accept='video/*'
					onChange={handleFileChange}
				/>
			</UploadContainer>
		)
	}

	return (
		<>
			<UploadContainer
				style={{
					backgroundImage: backgroundImage,
					alignItems: 'center',
					...style,
				}}>
				<span style={{ position: 'fixed' }}>Загрузка видео</span>
				<span style={{ marginLeft: 100 }}>{'.'.repeat(Math.floor(pointsAmount / 10))}</span>
			</UploadContainer>
			<div>Прогресс загрузки видео: {progress}</div>
		</>
	)
})
